import Cookies from '../helpers/CookiesHelper';

export default function initTracking() {
  Cookies.setCookie('contactShown', false, 1)
  // let consent = Cookies.getConsentLevel()

  // if (consent.tracking) {
  //   document.addEventListener( 'wpcf7mailsent', function( event ) {
  //     let contactFormID = event.detail.contactFormId
  //     window.ga( 'send', 'event', 'Contact Form', 'submit', contactFormID );
  //     window.ga('send', { 'hitType': 'pageview', 'page': '/formularz-kontaktowy/wyslano/', 'title': 'Formularz kontaktowy przesłany: ' + contactFormID })
  //     window.fbq('track', 'Contact');
  //   }, false );

  //   document.addEventListener('scroll', detectScrollInContact, false)
  //   document.addEventListener('touchmove', detectScrollInContact, false);
  // }
}

// function detectScrollInContact() {
//   if ($('#kontakt').length > 0) {
//     let contactShown = Cookies.returnCookie('contactShown')
//     var isVisible = isElementInViewport('#kontakt')
//     if (!contactShown && isVisible) {
//       window.ga( 'send', 'event', 'Contact Form', 'viewed' );
//       window.ga('send', { 'hitType': 'pageview', 'page': '/formularz-kontaktowy/wyswietlono/', 'title': 'Wyswietlono Formularz' })
//       Cookies.setCookie('contactShown', true, 0.1)
//     }
//   }
// }

// function isElementInViewport(elem) {
//   var elementTop = $(elem).offset().top;
//   var elementBottom = elementTop + $(this).outerHeight();

//   var viewportTop = $(window).scrollTop();
//   var viewportBottom = viewportTop + $(window).height();

//   return elementBottom > viewportTop && elementTop < viewportBottom;
// }



// WEBPACK FOOTER //
// ./scripts/components/tracking.js